/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Portals_Check_Hint_FieldInputs */

const cs_portals_check_hint_field = /** @type {(inputs: Portals_Check_Hint_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pole: ${i?.field}`)
};

const en_portals_check_hint_field = /** @type {(inputs: Portals_Check_Hint_FieldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Field: ${i?.field}`)
};

/**
* | output |
* | --- |
* | "Field: {field}" |
*
* @param {Portals_Check_Hint_FieldInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_check_hint_field = /** @type {((inputs: Portals_Check_Hint_FieldInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Check_Hint_FieldInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_check_hint_field(inputs)
	return cs_portals_check_hint_field(inputs)
});